import { useContext, useEffect, useState } from "react"
import getServices from "../services/getServices"
import postService from "../services/postService"
import deleteService from "../services/deleteService"
import { AuthContext } from "../contexts/auth"
import toast from "react-hot-toast"
import { useNavigate } from "react-router-dom"
import putService from "../services/putService"
import getServiceJson from "../services/getServiceJson"
import getServicesBlob from "../services/getServicesBlob"

const useLocalTarefa = () => {

    const { signOut } = useContext(AuthContext)
    const navigate = useNavigate()        
    const [cercaLocal, setCercaLocal] = useState({
        id: null,
        distancia_permitida: '',
        latitude: '',
        longitude: '',
        distancia_indefinida: false,
        coordenada_manual:false
    })

    const [enderecoLocal, setEnderecoLocal] = useState( {
        id:null,
        cep_id:null,
        cep: '',
        tipo: '',
        logradouro: '',
        complemento: '',
        numero: '',
        bairro: '',
        cidade: '',
        uf: ''
    })

    const [local, setLocal] = useState({id:null, 
                                        nome:'', endereco:'', 
                                        integracao:'', 
                                        clientpalo:null, 
                                        ativo:true, 
                                        editavel:true})    
    const [submit, setSubmit] = useState(false)
    
    const [postos, setPostos] = useState([])  
    const [postosSelecionados, setPostosSelecionados] = useState([])  

    const [tarefas, setTarefas] = useState([])  
    const [tarefasSelecionadas, setTarefasSelecionadas] = useState([])  
    
    const [qrcode, setQrcode] = useState('')  

    const _buscaQRcode = async (id) => {
        let result = await getServicesBlob(`admin/qrcodelocal/?id=${id}`)
        if (result.type === 'success'){
            const url = window.URL.createObjectURL(result.data);       
            setQrcode(url)
        }else{
            setQrcode('')
        }
    }

    const _buscaCep = async () => {
        setSubmit(true)
        let result = await getServices(`address/cep/${enderecoLocal.cep}/`)
        if (result.type === 'success'){
            let _enderecoLocal = {...enderecoLocal}
            _enderecoLocal.tipo = result.data.adress_type.name
            _enderecoLocal.logradouro = result.data.description
            _enderecoLocal.bairro = result.data.neighbourhoods.name
            _enderecoLocal.cidade = result.data.neighbourhoods.city.name
            _enderecoLocal.uf = result.data.neighbourhoods.city.state.initial
            _enderecoLocal.cep_id = result.data.id
            setEnderecoLocal(_enderecoLocal)
        }else{
            toast.error(`Cep:${enderecoLocal.cep} ${result.data.detail}.`)
        }
        setSubmit(false)
    }

    const _buscaGps = async () =>{
           let endereco = `${enderecoLocal.tipo}  ${enderecoLocal.logradouro} ${enderecoLocal.numero} ${enderecoLocal.complemento} ${enderecoLocal.bairro} ${enderecoLocal.cidade} ${enderecoLocal.uf} ${enderecoLocal.cep}`
           let jsonEndereco = {
            endereco : endereco
            }           
           let result = await getServiceJson('address/geolocalizacao/',jsonEndereco)
            if (result.type === 'success'){
                let _cercaLocal = {...cercaLocal}
                _cercaLocal.latitude = result.data.latitude
                _cercaLocal.longitude = result.data.longitude
                if  (!_cercaLocal.coordenada_manual){
                     setCercaLocal(_cercaLocal)
                }
                    
            }   
            else{
                toast.error(`Erro busca Gps:${result.data.detail}.`)
            }            
    }

    useEffect(()=>{
        if(enderecoLocal.cep.length===8){
            _buscaGps()
        }
    },[enderecoLocal])

    useEffect(()=>{
        if (postosSelecionados.length > 0){
            if (postosSelecionados[0]?.cep || local?.endereco === null || local?.endereco?.id === null){
                let postoSelecionado = postosSelecionados[0]
                setEnderecoLocal({
                        ...postoSelecionado,
                        id: null
                    }) 
            }
        }
    },[postosSelecionados])

    const _getLocal = async (id)=>{
        if (submit){
            return;
        }
        setSubmit(true)

        let result = await getServices(`admin/local/${id}/`)
        if (result.type === 'success'){
            setLocal(result.data)
            _buscaQRcode(id)

            if (result.data.posto){
                setPostosSelecionados([{
                    id: result.data.posto.id, 
                    name: `${result.data.posto.nome} (${result.data.posto.coligada})`
                  }])
            }

            if (result.data.tarefalocal){
                setTarefasSelecionadas(result.data.tarefalocal.map(item=>{return {
                    id:item.id, 
                    name: `${item.tipotarefa_nome}`,
                    clientpalo: item.clientpalo,
                    local: item.local,
                    tipotarefa: item.tipotarefa}}))
            }

            if (result.data.cerca.length > 0) {
                const primeiraCerca = result.data.cerca[0];
                setCercaLocal({
                    id : primeiraCerca.id,
                    distancia_permitida: primeiraCerca.distancia_permitida,
                    latitude: primeiraCerca.latitude,
                    longitude: primeiraCerca.longitude,
                    distancia_indefinida: primeiraCerca.distancia_indefinida,
                    coordenada_manual:  primeiraCerca.coordenada_manual
                })
            }

            if (result.data.endereco && result.data.endereco.id && result.data.endereco.id > 0){
                setEnderecoLocal({
                    id: result.data.endereco.id,
                    cep_id: result.data.endereco.postal_code.id,
                    cep: result.data.endereco.postal_code_cep,
                    tipo: result.data.endereco.adress_type_str,
                    logradouro: result.data.endereco.postal_code_description,
                    complemento: result.data.endereco.complement,
                    numero: result.data.endereco.number,
                    bairro: result.data.endereco.neighbourhoods_str,
                    cidade: result.data.endereco.city_str,
                    uf: result.data.endereco.state_uf
                   })
            }

        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        else if (result.data?.detail === 'Não encontrado.'){
            toast.error(result.data?.detail)
            navigate('/gestor/localtarefa') 
        }
        setSubmit(false)
    }

    const _getPostos = async ()=>{
        
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getServices(`admin/postosponto/`)
        if (result.type === 'success'){

            setPostos(result.data.map(item=>{return {id:item.id, 
                                                     cep_id: item.endereco?.postal_code.id,
                                                     name: `${item.nome} (${item.coligada?.name})`,
                                                     cep: item.endereco?.postal_code_cep,
                                                     tipo: item.endereco?.adress_type_str,
                                                     logradouro: item.endereco?.postal_code_description,
                                                     complemento: item.endereco?.complement,
                                                     numero: item.endereco?.number,
                                                     bairro: item.endereco?.neighbourhoods_str,
                                                     cidade: item.endereco?.city_str,
                                                     uf: item.endereco?.state_uf
                                                    } }))
           }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }    

    const _getTarefas = async ()=>{
        
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getServices(`admin/templateformulario/`)
        if (result.type === 'success'){
            setTarefas(result.data.results.map(item=>{return {id:item.id, 
                                                     name: `${item.tipotarefa.nome}`,
                                                     integracao: item.integracao, // incluido verificar se esta certo.
                                                     ativo : item.ativo,
                                                     editavel : item.editavel,
                                                     clientpalo: item.clientpalo,
                                                     local: null,
                                                     tipotarefa: item.tipotarefa.id}}))
           }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }    

    const _localFormularioPostPut = async () =>{
        if (submit){
            return;
        }
        setSubmit(true)

        if (!postosSelecionados || postosSelecionados.length === 0){
            toast.error('Selecione um posto, para salvar o local')
            setSubmit(false)
            return;
        }        

        // cadatra endereço
        let enderecoJson = {
            id: enderecoLocal.id,
            complement : enderecoLocal.complemento || null,
            number : enderecoLocal.numero || null,
            postal_code : enderecoLocal.cep_id
        }

        let resultEndereco
        if(enderecoJson.id){
            resultEndereco = await putService(`admin/endereco/${enderecoLocal.id}/`,enderecoJson)
        }else{
            resultEndereco = await postService('admin/endereco/',enderecoJson)
        }

        
        if (resultEndereco.data?.code === 'token_not_valid'){
            setSubmit(false)
            signOut()
            return;
        }
        else if (resultEndereco.type !== 'success'){
            toast.error('O endereço não é valido para registro.')
            setSubmit(false) 
            return;
        }

        //await aguarda terminar  o _buscaGps() para continuar o codigo
        await _buscaGps()
        
        //cadastra local
        let enderecoRetorno = resultEndereco.data
        if (!enderecoRetorno || !enderecoRetorno.id){
            toast.error('O endereço não é valido para registro.')
            setSubmit(false)
            return;
        } 
        let jsonLocal = {
            id: local.id,
            nome : local.nome,
            integracao : local.integracao ==='' ? null : local.integracao,
            ativo : local.ativo,
            posto : postosSelecionados[0].id,
            endereco : enderecoRetorno.id,
            clientpalo : local.clientpalo
        }

        let resultLocal
        if(local.id){
            resultLocal = await putService(`admin/local/${local.id}/`,jsonLocal)
        }else{
            resultLocal = await postService('admin/local/',jsonLocal)
        }

        if (resultLocal.data?.code === 'token_not_valid'){
            setSubmit(false)
            signOut()
            return;
        }
        else if (resultLocal.type !== 'success'){
            setSubmit(false) 
            return;
        }

        //cadatra cerca no local
        let localRetorno = resultLocal.data


        if (localRetorno.id){

            let jsonCerca = {
                id : cercaLocal.id,
                distancia_permitida : cercaLocal.distancia_permitida || 0,
                latitude : cercaLocal.latitude || 0,
                longitude : cercaLocal.longitude || 0,
                distancia_indefinida : cercaLocal.distancia_indefinida,
                coordenada_manual : cercaLocal.coordenada_manual,
                local: localRetorno.id
            }
            let resultCerca;
            //atualiza ou cria de acordo com o id
            if (cercaLocal.id) {
                resultCerca = await putService(`admin/cercalocal/${cercaLocal?.id}/`,jsonCerca)
            } else
            {
                resultCerca = await postService('admin/cercalocal/',jsonCerca)
            }
    
            if (resultCerca.data?.code === 'token_not_valid'){
                setSubmit(false)
                signOut()
                return;
            }
            else if (resultCerca.type !== 'success'){
                setSubmit(false) 
                return;
            }
        }
        let resultTarefas
        if (localRetorno.id){

            if(tarefasSelecionadas.length>0){
                tarefasSelecionadas.forEach(tarefa => {
                    tarefa.local = localRetorno.id
                  });
        
                resultTarefas = await postService(`admin/tarefaspermitidas/${localRetorno.id}/`,tarefasSelecionadas)
            }else{
                resultTarefas = await deleteService(`admin/tarefaspermitidas/${localRetorno.id}/`)                
            }

            if (resultTarefas.data?.code === 'token_not_valid'){
                setSubmit(false)
                signOut()
                return;
            }
            else if (resultTarefas.type !== 'success'){
                setSubmit(false) 
                return;
            }

        }

        navigate('/gestor/localtarefa')  
        setSubmit(false)            
    }


    return {
        submit: {value: submit, set: _getLocal},
        cep: {value: submit, set: _buscaCep},
        local: {value: local, set:setLocal},
        enderecoLocal: {value: enderecoLocal, set: setEnderecoLocal},
        postos: {value: postos, set: _getPostos},     
        postosSelecionados: {value: postosSelecionados, set: setPostosSelecionados},  

        tarefas: {value: tarefas, set: _getTarefas},     
        tarefasSelecionadas: {value: tarefasSelecionadas, set: setTarefasSelecionadas},  

        localFormularioPostPut: {value: submit, set: _localFormularioPostPut},        

        cercaLocal:{value: cercaLocal, set: setCercaLocal},
        qrcode : {value:qrcode, set:setQrcode},
    }
}

export default useLocalTarefa